module.exports = __webpack_public_path__ + "zendesk-3-87908b79cfe7655f5c402633767fd1a2.webp";